import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const text = t("marquee");
  const row = Array(6).fill(text);
  return (
    <div className="relative py-10 md:py-14 overflow-hidden border-y border-warm-grey/30 bg-cream-light" data-testid="marquee-section">
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((txt, i) => (
              <span key={`${half}-${i}`} className="font-serif italic text-3xl md:text-5xl text-brown/40 px-6">
                {txt}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
